module.exports = {"220173001":"硅谷街道","220173002":"北湖街道","220173200":"奋进乡","220173201":"双德乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220173.json
// module id = 613
// module chunks = 0